import { type FC, useEffect } from 'react';

import { useAppDispatch } from '../../../hooks/useThunkDispatch';
import { currentPageActions } from '../../../store/slices/currentPage/currentPageSlice';
import type { PageHeadData, PageHeadPagination } from '../../atoms/PageHead';
import PageHead from '../../atoms/PageHead';
import { useGaVirtualPageView } from './PageProperties.hooks';

interface PagePropertiesProps {
    headData: PageHeadData;
    headPagination?: PageHeadPagination;
    pageTypeNameForAnalytics?: string;

    /** @see useGaVirtualPageView comments */
    virtualPageViewQueryStringTriggers?: string[];
}

const PageProperties: FC<React.PropsWithChildren<PagePropertiesProps>> = (props) => {
    useGaVirtualPageView({
        canonicalUrl: props.headData.link?.canonical,
        pageTitle: props.headData.title,
        pageTypeName: props.pageTypeNameForAnalytics,
        queryStringTriggers: props.virtualPageViewQueryStringTriggers,
    });

    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(currentPageActions.setTitle(props.headData.title));
    }, [dispatch, props.headData.title]);

    return <PageHead data={props.headData} pagination={props.headPagination} />;
};

export default PageProperties;
